/**
 * The canonical form of a station identifier: lowercase.
 *
 * 🔑 ONE definition, shared by the URL builders and the telemetry stamps, because they
 * MUST agree about what a station is called. `api.js` has always lowercased the station
 * to build a path (the API 404s on an uppercase slug), so lowercase was already the
 * canonical form in this system — but the Faro stamps passed the customer's embed-code
 * spelling straight through, and nothing compared the two.
 *
 * 🔴 THE DEFECT THAT PRODUCED. The `station` query parameter is pasted into the embed by
 * the customer, verbatim, in whatever case they typed. MEASURED in Faro RUM on postv4
 * over 13h (2026-08-20): 162 distinct `user_attr_station` values, including both
 * spellings of the same station — `KTICAM` 6,195 events against `kticam` 1,957, `ktsaam`
 * 5,837 against `KTSAAM` 1,519, `kbry` 1,939 against `KBRY` 1,281. Every per-station
 * aggregate showed one station as two rows, and neither row was the real number.
 *
 * (`KRVNFM` vs `KRVNAM` is NOT an instance of this — those are genuinely different
 * stations, FM and AM. The defect is same-name-different-case only.)
 *
 * Normalising at the stamp loses nothing recoverable: what the customer actually typed
 * still rides `meta.page.url`'s query string, which Faro keeps.
 *
 * Returns `''` rather than null/undefined for every absent-ish input — the stamps guard
 * on truthiness, and a null reaching a Faro attributes bag (typed `Record<string,string>`)
 * would be coerced to the literal string "null".
 *
 * No `??`/optional chaining (the pinned ES2015 `src/` ban).
 */
export function normalizeStation(station) {
  return station ? String(station).toLowerCase() : '';
}
